module.exports = __webpack_public_path__ + "asset/image-Books-e19c19b233b61088.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Books.svg
// module id = 1p0f
// module chunks = 0